import { Component, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { fuseAnimations } from '@fuse/animations';
import { FuseSidebarService } from '@fuse/components/sidebar/sidebar.service';
import { Observable, Subject, Subscription } from 'rxjs';
import { Cotizador } from '../../models/cotizador';
import { CotizadorService } from '../../services/cotizador.service';
import { Prospecto } from '../../models/prospecto';
import { ValoresGarantizaService } from '../../services/valores-garantizados.service';
import { ValoresGarantizados } from '../../models/valoresGarantizados';
import { NgBlockUI, BlockUI } from 'ng-block-ui';


@Component({
    selector: 'app-cotizador',
    templateUrl: './cotizador.component.html',
    styleUrls: ['./cotizador.component.scss'],
    encapsulation: ViewEncapsulation.None,
    animations: fuseAnimations
})
export class CotizadorComponent implements OnInit, OnDestroy {
    private unsubscribeAll: Subject<any>;
    tabSeleccionada = 0;
    formaPagoVisible = true;
    botonValoresVisible = false;
    prospecto: Prospecto;
    @BlockUI() blockUI: NgBlockUI;

    tablaValoresGarantizados: [ValoresGarantizados];
    comisionSelected = 'DECRECIENTES';
    /**
     *
     * @param formBuilder provee de funciones y objetos para la creacion y validación de formas.
     */
    constructor(private _fuseSidebarService: FuseSidebarService,
        private cotizadorService: CotizadorService
    ) {
        this.unsubscribeAll = new Subject();
    }

    /**
     * Toggle sidebar
     *
     * @param name
     */
    toggleSidebar(name): void {
        this._fuseSidebarService.getSidebar(name).toggleOpen();
    }

    /**
     * Este metodo se ejecuta al inciar el componente,
     * Creamos el formulario, nos subscribimos a la accion de creacion exitosa y mostramos mensaje,
     * creamos los observables para el listado de cotizador y el paginado, y cargamos los cotizador por default,
     * tambien reiniciamos el formulario.
     */
    ngOnInit(): void {
        this.cotizadorService.getProspecto().subscribe((prospecto: Prospecto) => {
            if (prospecto.genero != "" && prospecto.habito != "" && prospecto.edad != "") {
                this.botonValoresVisible = true;
            } else {
                this.botonValoresVisible = false;
            }
            this.prospecto = prospecto;
        });


    }

    /**
     * 
     * @param tabSeleccionada 
     */
    prospectoCambiaTab(tabSeleccionada): void {
        this.tabSeleccionada = tabSeleccionada;
    }

    /**
     * Este método se ejecuta cuando el componente es destruido y eliminamos las subscripciones que esten activas.
     */
    ngOnDestroy(): void {
        this.unsubscribeAll.next();
        this.unsubscribeAll.complete();
    }

    valoresGarantizados(): void {
        this.prospecto.comision = this.comisionSelected;
        
        this.blockUI.start('Procesando...');
        this.cotizadorService.obtenerValoresGarantizados
            (
                this.prospecto
            ).subscribe(data => {
                if (data.valores.length > 0) {
                    this.tablaValoresGarantizados = data.valores;
                    this.formaPagoVisible = false;
                    this.botonValoresVisible = false;

                    this.cotizadorService.setValoresGarantizados(this.tablaValoresGarantizados);
                    this.tabSeleccionada = 3;
                }

                this.blockUI.stop();
            });


    }

    indexChange(tab): void {
        this.tabSeleccionada = tab;

        if (tab == 0) {
            this.formaPagoVisible = true;
            this.botonValoresVisible = true;
            this.tabSeleccionada = 0;
        }
        if (tab == 1) {
            if (this.prospecto.nombre != '' || this.prospecto.genero != '' || this.prospecto.habito != '' || this.prospecto.edad != '') {
                this.formaPagoVisible = true;
                this.botonValoresVisible = true;
                this.tabSeleccionada = 1;
            } else {
                this.tabSeleccionada = 0;
            }

        }
        if (tab == 2) {
            this.valoresGarantizados();
        }



    }

    indexChangeComision(evento: any): void {

    }
}
